import { cn } from "@/lib/utils";

const CHIP = {
  Queued: "bg-brand-tint text-brand border-[#C9DACE]",
  Processing: "bg-info-tint text-info border-[#CDD7E2]",
  Ready: "bg-success-tint text-success border-[#CADBCF]",
  "Needs review": "bg-caution-tint text-caution border-[#E8D7B0]",
  Sent: "bg-info-tint text-info border-[#CDD7E2]",
  Opened: "bg-brand-tint text-brand border-[#C9DACE]",
  "In progress": "bg-teal-tint text-teal border-[#CBD8CF]",
  Completed: "bg-success-tint text-success border-[#CADBCF]",
  Expired: "bg-subtle text-ink-muted border-line",
  Skipped: "bg-subtle text-ink-secondary border-line",
  Failed: "bg-risk-tint text-risk border-[#E8C9C5]",
};

export const StatusChip = ({ status, label, testId, className }) => {
  if (!status) return null;
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium",
        CHIP[status] || CHIP.Skipped,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full bg-current", status === "Processing" && "animate-pulse")} />
      {label || status}
    </span>
  );
};

export const queueLabel = (s) => ({ queued: "Queued", running: "Processing", completed: "Ready", failed: "Failed" }[s]);

export const analysisLabel = (s) =>
  ({ queued: "Queued", processing: "Processing", needs_review: "Needs review", confirmed: "Ready", failed: "Failed" }[s]);

const JOB = {
  draft: "bg-subtle text-ink-secondary border-line",
  open: "bg-teal-tint text-teal border-[#CBD8CF]",
  paused: "bg-caution-tint text-caution border-[#E8D7B0]",
  closed: "bg-[#F1EEE7] text-ink-muted border-line",
};

export const JobStatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId}
    className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize", JOB[status])}
  >
    {status}
  </span>
);
